export default {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCEL_PENDING: 'CANCEL_PENDING',
  CANCELLED: 'CANCELLED',
  PAST_DUE: 'PAST_DUE'
};



// WEBPACK FOOTER //
// ./src/constants/membershipStatuses.js